import React, { ReactNode } from 'react';
import { PullToRefresh, Toast } from 'antd-mobile';
import { useNetwork } from '../hooks/useNetwork';

interface PullToRefreshWrapperProps {
  children: ReactNode;
  onRefresh: () => Promise<void>;
  pullingText?: string;
  canReleaseText?: string;
  refreshingText?: string;
  completeText?: string;
  networkErrorText?: string;
  refreshFailedText?: string;
  checkNetwork?: boolean;
}

const PullToRefreshWrapper: React.FC<PullToRefreshWrapperProps> = ({
  children,
  onRefresh,
  pullingText = 'pull to refresh',
  canReleaseText = 'Release and refresh immediately',
  refreshingText = 'refreshing...',
  completeText = 'Refresh completed',
  networkErrorText = 'Network connection unavailable',
  refreshFailedText = 'Refresh failed, please try again later',
  checkNetwork = true,
}) => {
  const { isOnline } = useNetwork();

  const handleRefresh = async () => {
    if (checkNetwork && !isOnline) {
      Toast.show({
        content: networkErrorText,
        position: 'bottom',
      });
      return;
    }

    try {
      await onRefresh();
    } catch (error) {
      Toast.show({
        content: refreshFailedText,
        position: 'bottom',
      });
    }
  };

  return (
    <PullToRefresh
      onRefresh={handleRefresh}
      pullingText={pullingText}
      canReleaseText={canReleaseText}
      refreshingText={refreshingText}
      completeText={completeText}
    >
      {children}
    </PullToRefresh>
  );
};

export default PullToRefreshWrapper; 